module.exports = __webpack_public_path__ + "img/BG_quan2@2x.80f00908.png";